























































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import { routerPath } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'
/* api */
import stageUpdateApi from '@/app/model/api/stageUpdateApi'

@Component
export default class StageUpdateModal extends Vue {
  private stageData: {[key: string]: number|string|any} = {}
  private variableDay: string = ''
  private defaultDay: string = ''
  private changeId: number = 0
  private errorMessage: string = ''
  private showStageUpdateDetail: boolean = false

  /* computed */
  private get stageUpdateId (): number {
    return this.$store.state.stageUpdateState.changeStageId
  }

  @Watch('stageUpdateId')
  onChangeId (val: any) {
    this.changeId = val
    let growthList = JSON.parse(Session.getGrowthStage()!)

    for (var i in growthList) {
      if (growthList[i].id === val) {
        this.defaultDay = this.getDate(growthList[i].days)
        this.variableDay = this.getDate(growthList[i].days)
        this.stageData = growthList[i]

        // 更新履歴表示切替
        if (this.stageData.growth_stage_histories.length !== 0) {
          this.showStageUpdateDetail = true
        } else {
          this.showStageUpdateDetail = false
        }
      }
    }
  }

  private getDate (days: number) {
    let plantingDay = parseInt(Session.getPlantingDay()!)
    let newDay = new Date(DateClass.formingDate(plantingDay).getTime() + days * 24 * 60 * 60 * 1000)
    return newDay.getFullYear() + '-' + DateClass.toDoubleDigits(newDay.getMonth() + 1) + '-' + DateClass.toDoubleDigits(newDay.getDate())
  }

  private setNewData () {
    const diff = (new Date(this.variableDay).getTime() - new Date(this.defaultDay).getTime()) / (1000 * 60 * 60 * 24)

    let growthList = JSON.parse(Session.getGrowthStage()!)
    let current:any = {}
    let previous:any = {}
    let after:any = {}

    /* 前後のステージを取得 */
    for (var i in growthList) {
      if (growthList[i].id === this.changeId) {
        current = growthList[i]
      }

      if (growthList[i].id === this.changeId + 1) {
        after = growthList[i]
      }

      if (growthList[i].id === this.changeId - 1) {
        previous = growthList[i]
      }
    }

    /* ステージの範囲内で日付を変更 */
    if ((current.days + diff) <= previous.days) {
      this.errorMessage = previous.name + '以前の日程は入力できません。'
    } else if ((current.days + diff) <= previous.days && Object.keys(previous).length === 0) {
      this.errorMessage = previous.name + '以前の日程は入力できません。'
    } else if ((current.days + diff) >= after.days) {
      this.errorMessage = after.name + '以降の日程は入力できません。'
    } else if ((current.days + diff) >= after.days && Object.keys(after).length === 0) {
      this.errorMessage = after.name + '以降の日程は入力できません。'
    } else {
      this.errorMessage = ''
      this.upDateStageData(diff)
      this.defaultDay = this.variableDay
    }
  }

  private closeModal () {
    this.variableDay = this.defaultDay
    this.$emit('close-modal')
  }

  private async upDateStageData (diff: number) {
    let date = this.defaultDay.slice(0, 4) + this.defaultDay.slice(5, 7) + this.defaultDay.slice(8, 10)
    let growthList = JSON.parse(Session.getGrowthStage()!)
    let plantingId = parseInt(Session.getPlantingId()!)

    const bodyData = {
      'planting_id': plantingId,
      'stage_id': this.stageData.id,
      'date': date,
      'diff': diff
    }

    const result = await stageUpdateApi.updateStage(bodyData)

    if (result.isOk()) {
      diff = 0
      this.$emit('reacquire-stage')
      this.$emit('close-modal')
    } else if (result.checkTimeoutErrorStatus()) {
      this.$store.commit('routeState/setTimeoutErrorFlag', true)
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkErrorStatus()) {
      this.$store.commit('routeState/setErrorFlag', true)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkNotFoundStatus()) {
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkStatus()) {
      CommonClass.doLogout()
    } else {
      this.$emit('show-error-alert', result.getPayload().message)
    }
  }

  private createUpdateDate (date: any) {
    if (date !== '') {
      const updateDate = new Date(date)
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '/' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate()) + ' ' + DateClass.toDoubleDigits(updateDate.getHours()) + ':' + DateClass.toDoubleDigits(updateDate.getMinutes())
      return formingDate
    }
  }

  private createBeforeStageDate (date: any) {
    if (date !== '') {
      const updateDate = new Date(date)
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '/' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate())
      return formingDate
    }
  }

  private nextDate () {
    let newDate = new Date(new Date(this.variableDay).getTime() + 1 * 24 * 60 * 60 * 1000)
    this.variableDay = newDate.getFullYear() + '-' + DateClass.toDoubleDigits(newDate.getMonth() + 1) + '-' + DateClass.toDoubleDigits(newDate.getDate())
  }

  private prevDate () {
    let newDate = new Date(new Date(this.variableDay).getTime() - 1 * 24 * 60 * 60 * 1000)
    this.variableDay = newDate.getFullYear() + '-' + DateClass.toDoubleDigits(newDate.getMonth() + 1) + '-' + DateClass.toDoubleDigits(newDate.getDate())
  }
}
